module.exports = __webpack_public_path__ + "static/media/question.87694621.png";